import { t } from 'i18next'

import * as yup from 'yup'

import { IFormModel } from 'types'

/**
 * Form constants
 */
const CODE = 'code'
const TITLE = 'title'
const DIAGNOSTIC_INDICATION = 'diagnostic_indicator'
const SUBJECT = 'subject'
const DOMAIN = 'domain'
const CLUSTER = 'cluster'
const COMPLEXITY = 'complexity'
const KNOWLEDGE_TYPE = 'knowledge_type'
const ZPD_ANCHOR= 'zpd_anchor'
const DOK_LEVEL = 'dok_level'

/**
 * Form model
 */
const formModel = (): IFormModel => {
  return {
    [CODE]: {
      label: `${t('common.code')}`,
      name: CODE,
      required: true,
    },
    [TITLE]: {
      label: `${t('common.statement')}`,
      name: TITLE,
      required: true,
    },
    [DIAGNOSTIC_INDICATION]: {
      label: `${t('common.diagnostic-indication')}`,
      name: DIAGNOSTIC_INDICATION,
    },
    [SUBJECT]: {
      label: `${t('common.subject')}`,
      name: SUBJECT,
      required: true,
    },
    [DOMAIN]: {
      label: `${t('common.domain')}`,
      name: DOMAIN,
      required: true,
    },
    [CLUSTER]: {
      label: `${t('goalbank.cluster')}`,
      name: CLUSTER,
      required: true,
    },
    [COMPLEXITY]: {
      label: `${t('common.cognitive-verb')}`,
      name: COMPLEXITY,
    },
    [KNOWLEDGE_TYPE]: {
      label: `${t('common.knowledge-type')}`,
      name: KNOWLEDGE_TYPE,
      required: true,
    },
    [ZPD_ANCHOR]: {
      label: `${t('common.zpd-anchor')}`,
      name: ZPD_ANCHOR,
      required: true,
    },
    [DOK_LEVEL]: {
      label: `${t('common.dok-level')}`,
      name: DOK_LEVEL,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [CODE]: '',
  [TITLE]: '',
  [DIAGNOSTIC_INDICATION]: '',
  [SUBJECT]: null,
  [DOMAIN]: null,
  [CLUSTER]: null,
  [COMPLEXITY]: null,
  [KNOWLEDGE_TYPE]: null,
  [ZPD_ANCHOR]: null,
  [DOK_LEVEL]: null,
}

/**
 * Form data validation
 */
export const validationSchema = () =>
  yup.object().shape({
    [CODE]: yup.string().required(`${t('errors.required-error-message')}`),
    [TITLE]: yup.string().required(`${t('errors.required-error-message')}`),
    [CLUSTER]: yup.object().required(`${t('errors.required-error-message')}`),
  })

export default formModel
